import { useEffect, useState } from "react";
import api from "@/lib/api";

// Competitor prices maintained by the monthly crawl (backend/services/competitor_prices.py).
// Returns null until loaded or when the request fails, so pages fall back to their built-in values.
export function useCompetitorPrices() {
  const [prices, setPrices] = useState(null);
  useEffect(() => {
    api.get("/public/competitor-prices").then((r) => setPrices(r.data)).catch(() => {});
  }, []);
  return prices;
}

export function formatChecked(iso) {
  const d = iso ? new Date(iso) : new Date();
  return d.toLocaleDateString("nl-NL", { day: "numeric", month: "long", year: "numeric" });
}

export const fmtNum = (n) => n.toLocaleString("nl-NL");
